import { apiDaInscricao } from "../../../servicos/axios";

export type ApiServico = {
  id: number;
  grupo: string; // ex: "Atendimento", "Convocação", etc.
  nome: string; // ex: "Orientação"
  valor: string; // ex: "orientacao" (slug/code para usar no form)
};

// GET /servicos
// O backend pode devolver { servicos: [...] } OU diretamente um array.
// A função abaixo cobre os dois formatos.
export async function buscarServicos(): Promise<ApiServico[]> {
  const api = apiDaInscricao();
  const resp = await api.get("/servico");

  const bruto = resp?.data;
  const lista = bruto?.servicos ?? bruto ?? [];

  // Garante tipagem mínima mesmo se vierem campos extras
  return (Array.isArray(lista) ? lista : []) as ApiServico[];
}
